<template>
  <div>
    <el-dialog
      title="审批"
      :visible.sync="dialogVisible"
      append-to-body
      width="30%"
      center
      @close="closeDialog"
    >
      <div class="result" style="text-align: center">
        <div style="margin: 20px 0"></div>
        <el-form :model="baseInfoData" ref="closeReasonForm" label-width="120px">
          <el-form-item label="审批信息" prop="approvalComment">
            <el-input
              type="textarea"
              placeholder="请输入审批信息"
              v-model="baseInfoData.approvalComment"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reject">驳回</el-button>
        <el-button type="primary" @click="pass(true)">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';

  export default {
    name: 'approvalDialog',
    data() {
      return {
        dialogVisible: false,
        baseInfoData: { approvalComment: '' },
        ids: [],
      };
    },
    methods: {
      openDialog({ ids }) {
        this.dialogVisible = true;
        console.log('ids', ids);
        this.ids = ids;
      },

      // 关闭弹窗
      closeDialog() {
        this.$refs.closeReasonForm.resetFields();
        this.baseInfoData.approvalComment = '';
      },
      // 驳回
      reject() {
        if (!this.baseInfoData.approvalComment) {
          this.$message.error('请填写审批信息');
          return;
        }
        this.approvalreceivable({ type: 2 });
      },
      // 通过
      async pass() {
        this.approvalreceivable({ type: 1 });
      },
      async approvalreceivable({ type = 1 }) {
        const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLE_APPROVAL_API, {
          approvalComment: this.baseInfoData.approvalComment,
          settlementNos: this.ids,
          type: type,
        });
        if (data.code === 0) {
          this.$message.success('操作成功');
          this.dialogVisible = false;
          this.$emit('approvalSuccess');
        } else {
          this.$message.error(`${data.msg}`);
        }
      },
    },
  };
</script>

<style></style>
